/**
 * Wraps a dynamic import function to retry once on ChunkLoadError.
 * This handles the common case where a deploy invalidates cached chunks.
 *
 * Usage with next/dynamic:
 *   dynamic(() => retryDynamicImport(() => import('./MyComponent')))
 */
export async function retryDynamicImport<T>(
  importFn: () => Promise<T>,
): Promise<T> {
  try {
    return await importFn();
  } catch (error) {
    if (
      error instanceof Error &&
      (error.message.includes('ChunkLoadError') ||
        error.message.includes('Loading chunk'))
    ) {
      // Retry once -- the browser may fetch the updated chunk on second attempt
      return await importFn();
    }
    throw error;
  }
}
